<template lang="pug">
  div
    .seach-pagination-container
      .search-container
        img(src="@/assets/icon/chat-search.svg", class="text-search", alt="search", height="18", width="17")
        input(type="text", placeholder="ค้นหา", v-model="searchText", @input="search", @keyup.enter="search")
        img(v-if="searchText !== ''", src="@/assets/icon/chat-clear.svg", class="text-clear", alt="clear", height="13", width="13", @click="clearSearch()")
      el-pagination(layout="prev, pager, next", :total="totalItems", :page-size="perPage", @current-change="setPage", :current-page.sync="page").left-pagination
    el-table(v-loading="loading" id="customer-table", :data="list", style="width: 100%", @row-click="rowClick").table
      el-table-column(prop="createdAt", label="สร้างเมื่อ", width="200")
      el-table-column(prop="code", label="เลขคนไข้", width="100")
        template(slot-scope="scope")
          span(style="font-family: 'Sukhumvit-Bold';") {{ scope.row.code }}
      el-table-column(prop="contactName", label="ชื่อผู้ติดต่อ", width="250")
        template(slot-scope="scope")
          span(style="font-family: 'Sukhumvit-Bold';") {{ scope.row.contactName }}
      el-table-column(prop="patientName", label="ชื่อคนไข้", width="175")
      el-table-column(prop="phone", label="เบอร์โทร", width="180")
      el-table-column(prop="service", label="รูปแบบงาน", width="160")
      el-table-column(prop="area", label="สถานที่ดูแล", width="160")
      el-table-column(label="สถานะ", min-width="140")
        template(slot-scope="scope")
          .el-status(:class="scope.row.status")
            .el-badge__content.status(v-if="scope.row.statusText === 'หาคน'") {{ scope.row.statusBadge }}
            span {{ scope.row.statusText }}
</template>

<style lang="scss">
  .el-table.table td, .el-table.table th {
    padding: 6px 0;
  }

  .has-gutter > tr > th {
    font-family: 'Sukhumvit-SemiBold';
  }

  i.el-icon-bell {
    color: #339AF0;
  }

  .el-status:hover {
    cursor: pointer;
  }

  .el-status {
    position: relative;
    width: 90px;
    height: 36px;
    color:white;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .el-status.reserved {
    background-color:#D5D6DB;
    border-color:#D5D6DB;
  }

  .el-status.booking, .el-status.waiting {
    background-color:#A9C4FF;
    border-color:#A9C4FF;
  }

  .el-status.matched, .el-status.working {
    background-color:#446CC6;
    border-color:#446CC6;
  }

  .el-badge__content.status {
    border: none;
    position: absolute;
    top: -7px;
    right: -5px;
    width: auto;
    height: 16px;
    font-size: 10px;
  }

  .el-pagination {
    margin-top: 0px !important;
  }

  .el-pager {
    display: flex;
    justify-content: center;

    .number {
      width: 35.5px;
      height: 35.5px;

      &.active {
        background: #5489FF;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
      }
    }
  }
</style>

<style lang="scss" scope>
  .left-pagination {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 32px;
  }

  .seach-pagination-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .search-container {
    display: flex;
    justify-content: center;
    position: relative;
    margin-bottom: 32px;

    input {
      width: 346px;
      height: 40px;
      border-radius: 20px;
      border: solid 1px #dcdfe6;
      background-color: #FFFFFF;
      outline: 0;
      padding: 8px 44px 6px 44px;
      font-family: 'Sukhumvit-Medium';
      font-size: 16px;
      color: #303133;

      &::placeholder {
        font-family: 'Sukhumvit-SemiBold';
        font-size: 16px;
        color: #c0c4cc;
      }
    }

    .text-search {
      position: absolute;
      top: 10px;
      left: 14px;
    }

    .text-clear {
      position: absolute;
      top: 13px;
      right: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>

<script>
export default {
  name: 'PatientTable',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      page: 1,
      pageSize: 500,
      searchText: '',
    }
  },
  methods: {
    search () {
      this.$emit('search', this.searchText)
    },
    rowClick (rowItem, column, event) {
      this.$emit('didSelectRow', rowItem, event)
    },
    setPage (val) {
      this.page = val
      this.$emit('page', this.page)
    },
    clearSearch () {
      this.searchText = ''
      this.$emit('search', this.searchText)
    },
  },
}
</script>
